import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import { AdvancedTrackDefinition, AdvancedTrackSummary } from '../api/types'
import { trackStatusLabel, trackTitle } from '../dashboard/tracks/trackTransitions'
import { onDark } from '../theme'

type Props = { tracks: AdvancedTrackSummary[]; catalog: AdvancedTrackDefinition[]; stalledKeys: string[] }

const TrackSummaryList = ({ tracks, catalog, stalledKeys }: Props) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
    {tracks.map((track) => (
      <Box
        key={track.trackKey}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            sx={{ color: track.endedAt ? onDark.secondary : onDark.primary, fontWeight: 600 }}
          >
            {trackTitle(catalog, track.trackKey)}
          </Typography>
          <Typography variant="subtitle2" sx={{ color: onDark.secondary }}>
            {`${track.completedCount} completed${track.endedAt ? ` · ${trackStatusLabel(track)}` : ''}`}
          </Typography>
        </Box>
        {!track.endedAt && stalledKeys.includes(track.trackKey) && (
          <Chip
            size="small"
            variant="outlined"
            label="Stalled"
            sx={{ height: 22, color: onDark.yellowAccent, borderColor: onDark.yellowAccent }}
          />
        )}
      </Box>
    ))}
  </Box>
)

export default TrackSummaryList
